module.exports = __webpack_public_path__ + "static/media/63.ac7e68c6.png";